module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Patient-Zero.7968176.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Patient-Zero.jpg
// module id = sNiP
// module chunks = 0